import { api } from "./api";
import { compressImageForUpload } from "./compressImage";

/** Uploads a poster / character design (shrunk first) and resolves to its address. */
export async function uploadImage(file, kind = "image") {
  const small = await compressImageForUpload(file, kind);
  const fd = new FormData();
  fd.append("file", small);
  const { data } = await api.post(`/upload?kind=${kind}`, fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.url;
}
